import { Component, inject, input, model, output, signal } from '@angular/core'
import { ModalHeaderComponent } from './modal-header/modal-header.component'
import { ModalFooterComponent } from './modal-footer/modal-footer.component'
import { NgbActiveModal, NgbAlert } from '@ng-bootstrap/ng-bootstrap'
import { ModalBodyComponent } from './modal-body/modal-body.component'
import { SpinnerComponent } from '../spinner/spinner.component'

@Component({
  imports: [
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    SpinnerComponent,
    NgbAlert,
  ],
  selector: 'app-export-modal',
  styles: `
    div[app-modal-body] {
      display: flex;
      flex-direction: column;
      padding-left: 1rem;
      padding-right: 1rem;
      min-height: 150px;
    }
    
    .content {
      flex-basis: 0;
      flex-grow: 1;
      padding-top: 1rem;
      .spinner-anchor {
        position: absolute;
        left: 50%;
        min-height: 50px;
        padding-top: 20px;
      }
    }
  `,
  template: `
    <div app-modal-header>{{title()}}</div>
    <div app-modal-body>
      <div class='content'>
          @if (loading()) {
            <div class="spinner-anchor">
              <app-spinner></app-spinner>
            </div>
          } @else {
            <ng-content/>
          }
      </div>
      <ngb-alert [dismissible]="false" [type]="loading() ? 'warning' : 'info'">{{alertMessage()}}</ngb-alert>
    </div>
    <div app-modal-footer>
      <button class="action-btn" (click)="onCancel()">Cancel</button>
      <button
        class="action-btn primary"
        (click)="onDownload()"
        [disabled]="loading()"
      >
        Download
      </button>
    </div>
  `,
})
export class ExportModalComponent {
  private readonly activeModal = inject(NgbActiveModal)

  readonly title = input.required<string>()
  readonly cancelled = model.required<boolean>()

  readonly download = output()

  protected readonly loading = signal(false)

  protected alertMessage(): string {
    return this.loading()
      ? 'Do not refresh this page until the download has been completed.'
      : 'Ready to download results as CSV.'
  }

  protected onCancel() {
    this.cancelled.set(true)
    this.activeModal.dismiss()
  }

  protected onDownload() {
    this.loading.set(true)
    this.download.emit()
  }
}
